import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table, Button} from 'react-bootstrap';
import swal from 'sweetalert';
import SvgIcon from 'react-icons-kit';
import moment from 'moment';
import Help from '../generics/help';

import ModalShippingDetails from '../distribution/shipping/modalDetailsShipping';
import ModalView from '../distribution/modalView';
import ModalViewPatient from './modalViewPatient';
import { search } from 'react-icons-kit/icomoon/search';
import { cross } from 'react-icons-kit/icomoon/cross';
import {print} from 'react-icons-kit/fa/print';

var Config = require('../../config');

class DeliberedSearch extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.onSearch = this.onSearch.bind(this);
		this.onPrint = this.onPrint.bind(this);
		this.viewDetails =this.viewDetails.bind(this);

		this.state = {
			folio:"",
			list:[],
		}

	}

	componentDidMount(){

		this.props.socket.onerror = (event)=> {
			console.log(event);
		};

		this.props.socket.onmessage = (event) => {
		    var res = JSON.parse(event.data);
		    if(res.Error !== undefined){
		    	swal('¡Error!', res.Error, 'error');
		    }
		    console.log(res);
		}

		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
	}

	handleChange(e){
		this.setState({
			[e.target.name]:e.target.value
		});
	}

	onSearch(){
		if(this.state.folio !== ""){
			this.props.waiting.handleShow('Cargando...');
			fetch(Config.default.apiGateway.URL+'units/search_exit_folio?folio='+this.state.folio+
				'&health_facilities_id='+sessionStorage.getItem('health_facilities_id'), {
				method: 'get',
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					})
				}
				
			}).then(response =>{
				if(response !== undefined){
					this.setState({list:response});
				}
			})
		}else{
			swal('Error', 'Debe ingesar un número de folio', 'error');
		}
		
	}

	modalDetails(e,item){
		e.preventDefault();
		item.unit_export = {
			id: item.id
		};

    	this.modal_view_information.handleShow(item);
	}

	changeStatus(id, type){

		if(type === 'PACIENTES'){
			this.props.history.push('/unit_return/'+id);
		}else{
			swal({
		        title: '¿Está seguro?',
		        text: '¿Desea retirar el envío?',
		        type: 'warning',
		        showCancelButton: true,
		        confirmButtonColor: '#DD6B55',
		        confirmButtonText: '¡Si, Retirar!',
		        cancelButtonText: '¡No, Cancelar!',
		        closeOnConfirm: true,
		        closeOnCancel: true
		    }, (isConfirm) => {
		        if (isConfirm) {

		        	var apiURL = 'unit_export/'+id;

		        	if(type === 'HEMORED'){
		        		apiURL = 'unit_request/delete_by_folio?folio='+id;
		        	}

		        	fetch(Config.default.apiGateway.URL+apiURL, {
			            method: 'delete',
			            headers: new Headers({
			               'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			               'Accept': 'application/json',
			              'Content-Type': 'application/json',
			            })
		          	}).then(res => {
		            	
		           	}).then(res => {
	                	swal('Buen Trabajo', 'Solicitud Retirada','success');
	            		this.onSearch();
		          	})
		        }
		    });
		}
			
	}

	async onPrint(e, id, type, file){
		e.preventDefault();
   		this.props.waiting.handleShow('Imprimiendo...');
				
	    var obj ={};
	    obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
	    obj.id = id;
	    obj.nEtiqueta = [0];
		obj.file_type = file;

		if(type === 'PACIENTES'){
			obj.copies = 1;
		}else{
			obj.option = type.toLowerCase();	
		}
		
		var type = await this.props.getDocumentType(obj.file_type);

		var document;
		if(type.print_type === 'template'){
			document = await this.props.printDocumentTemplate(obj, type.print_automatically);
		}else if(type.print_type === 'external'){
			document = await this.props.printDocumentExternal(obj, type.print_automatically);
		}

		if(document !== undefined){
			this.props.waiting.handleClose();
		}else{
			this.props.waiting.handleClose();
		}
	
		
	}

	directPrint(response, label_type){
	    //PRINTER
	    var reader = new FileReader();
	    reader.readAsDataURL(response); 
	    reader.onloadend = ()=>{
	      	var base64data = reader.result;  
	      	var aux = base64data.split(',');
	      	this.props.socket.send('{"Operacion":"print", "Type":"'+label_type+'", "File": "'+aux[1]+'"}');
	    }
  	}

  	viewDetails(e, title, id, folio){
  		if(title === ''){
  			this.modal_view_patient.handleShow(id, folio);
  		}else{
  			this.modal_view.handleShow(title, id);	
  		}
		
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
					    {sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.distribution.MAIN')} ->
						{t('sidebar.nav.distribution.delivered_search')}
					</h5>
				</div>
				
				<Help
					{...this.props} 
	              	menu={"help_distribution"} 
	              	submenu={"help_delibered_search"}  />
				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-sm-3">
						<span className="span-min">No. Folio de Envío</span>
						<input type="text" name="folio" id="folio" value={this.state.folio || ""} 
							onChange={this.handleChange} className="form-control" />
					</div>
					<div className="col-xs-12 col-sm-1" style={{marginTop:"11px"}}>
						<button type="button" className="btn btn-info" style={{fontSize:"1em"}}
							onClick={this.onSearch}>
							{t('content.generics.buttons.search')}
						</button>
					</div>
				</div>
				<div className="col-xs-12">
					<Table responsive hover>
						<thead>
							<tr>
								<th>Tipo</th>
								<th>Folio</th>
								<th>Destino</th>
								<th>Fecha Envío</th>
								<th>No. Unidades</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							{this.state.list.map((list, i)=>(
								<tr key={i}>
									<td>{list.type}</td>
									<td>{list.type === 'PACIENTES'? (list.folio+ " ("+list.petition_number+")"):list.folio}</td>
									<td>{list.center_receive}</td>
									<td>{moment(list.date).format('DD/MM/YYYY HH:mm')}</td>
									<td>{list.amount}</td>
									<td>
										<Button className="btn btn-info btn-xs" title="Ver" style={{marginRight:"5px"}} 
											onClick={(e)=>
												list.type === 'EXTERNO' ?
													this.modalDetails(e,list)
												:list.type === 'HEMORED' ?
													this.viewDetails(e,'Detalle Hemored', list.id,"")
												:this.viewDetails(e,'', list.id,list.folio)
											}>
											<SvgIcon icon={search} />
										</Button>

										<Button className="btn btn-info btn-xs" title="Imprimir" style={{marginRight:"5px"}}
											onClick={(e)=> 
												this.onPrint(e, 
													(list.type === 'PACIENTES' ? list.folio : list.id), 
													list.type, 
													(list.type === 'PACIENTES' ? 'transfusion_unit' 
													: list.type === 'HEMORED' ? 'unit_export_hemored' : 'unit_export')
												)
											}>
											<SvgIcon icon={print} />
										</Button>
										
										<Button className="btn btn-info btn-xs" title="Eliminar" style={{marginRight:"5px"}}
											onClick={list.type === 'EXTERNO' ?
												this.changeStatus.bind(this,list.id, 'EXTERNO')
											: list.type === 'HEMORED' ?
												this.changeStatus.bind(this,list.folio, 'HEMORED')
											:this.changeStatus.bind(this,list.id, 'PACIENTES')
											}>
											<SvgIcon icon={cross} />
										</Button>
									</td>
								</tr>
							))}
						</tbody>
					</Table>
				</div>
				<ModalShippingDetails {...this.props} onRef={ref => (this.modal_view_information = ref)} refresh={this.props.refresh} />
				<ModalView {...this.props} onRef={ref => (this.modal_view = ref)}/>
				<ModalViewPatient {...this.props} onRef={ref => (this.modal_view_patient = ref)}/>
			</div>
		)
	
	}
}

export default translate('translations') (DeliberedSearch);